module.exports = __webpack_public_path__ + "static/img/2.cd21c7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/hangye/20200930/2.png
// module id = 8wmu
// module chunks = 1